import React, { useEffect, useState } from "react";
import Logo from "../../Images/new logo 2.png";
import { useNavigate } from "react-router-dom";
import axios from "../../axios";
import { useTranslation } from "react-i18next";
import { errorToast } from "../../utils/toast";
import toast from "../../componant/Toast/Toast";
import { useUser } from "../../hooks/use-user";
// import OTPModal from "./OtpModal";
import Image from "../../Images/detailsPageImage.PNG";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
/* -------- Floating Input (Notched Border) -------- */
const NotchedInput = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  readOnly,
}) => {
  return (
    <div className="relative w-80 sm:w-72 md:w-96 lg:w-96 mt-6">
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        required
        className="peer w-full h-12 px-4 bg-transparent
                   border border-white/70 rounded-xl
                   text-white outline-none
                   focus:border-orange-400"
      />
      <label
        className="absolute left-4 top-1/2 -translate-y-1/2
                   text-white/60 bg-bgBlue px-1 transition-all
                   peer-focus:top-0 peer-focus:text-sm peer-focus:text-orange-400
                   peer-valid:top-0 peer-valid:text-sm"
      >
        {label}
      </label>
    </div>
  );
};

/* -------- Floating Select -------- */
const NotchedSelect = ({ label, name, value, onChange, options }) => {
  return (
    <div className="relative w-80 sm:w-72 md:w-96 lg:w-96 mt-6">
      <select
        name={name}
        value={value}
        onChange={onChange}
        required
        className="peer w-full h-12 px-4 bg-transparent
                   border border-white/70 rounded-xl
                   text-white outline-none
                   focus:border-orange-400"
      >
        <option value="" disabled hidden></option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} className="text-black">
            {opt.label}
          </option>
        ))}
      </select>
      <label
        className="absolute left-4 top-1/2 -translate-y-1/2
                   text-white/60 bg-bgBlue px-1 transition-all
                   peer-focus:top-0 peer-focus:text-sm peer-focus:text-orange-400
                   peer-valid:top-0 peer-valid:text-sm"
      >
        {label}
      </label>
    </div>
  );
};

/* ---------------- MAIN ---------------- */
const WatsApp = () => {
  const navigate = useNavigate();
  const [t] = useTranslation();
  const [states, setStates] = useState([]);

  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    qualification: "",
    userState: "",
    mobile: "",
    mobileVerified: true,
    loginType: "",
    termsAccepted: false,
    privacyAccepted: false,
    isAdultConfirmed: false,
    consentAcceptedAt: "2025-01-05T12:10:00Z",
  });

  const { data: fetchedUser } = useUser();

  /* -------- Prefill Profile from fetched user -------- */
  useEffect(() => {
    if (!fetchedUser) return;
    setFormData((prev) => ({
      ...prev,
      name: fetchedUser.name || "",
      qualification: fetchedUser.qualification || "",
      userState: fetchedUser.userState || "",
      mobile: fetchedUser.mobile || "",
      email: fetchedUser.email || "",
      loginType: fetchedUser.loginType || "",
    }));
  }, [fetchedUser]);

  /* -------- Fetch States -------- */
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await axios.get("/all");
        setStates(res.data?.data || []);
      } catch (err) {
        toast(err.response?.data?.message || "Failed to fetch states", 3000);
      }
    };
    fetchStates();
  }, []);

  /* -------- Update User -------- */
  const updateUser = async () => {
    try {
      const res = await axios.post("/userUpdate", formData);

      if (res.data.result.mobileVerified) {
       console.log(res.data.result.mobileVerified,"mobileVerified");
       
        navigate("/dash");
      } else {
        console.log(
          res.data.result.mobileVerified,
          "mobileVerified Not verify",
        );
        toast("Phone Number Already Exist", 3000);
      }
    } catch (err) {
      console.log("Update user error:", err.response?.data);

      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Phone number already exists";

      errorToast(msg);
    }
  };

  /* -------- Validation -------- */
  const validateForm = () => {
    if (!formData.name.trim()) return errorToast("Please enter full name");
    if (!formData.email.trim()) return errorToast("Please enter email");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email))
      return errorToast("Please enter valid email");
    if (!formData.qualification) return errorToast("Please select education");
    if (!formData.userState) return errorToast("Please select state");
    if (
      !formData.isAdultConfirmed ||
      !formData.termsAccepted ||
      !formData.privacyAccepted
    ) {
      return errorToast(
        "Please accept terms & conditions and privacy policy to continue",
      );
    }

    return true;
  };

  /* -------- Submit -------- */
  const handleSubmit = async () => {
    if (!validateForm()) return;

    const isValidMobile = (mobile) => /^(\+91)?[6-9]\d{9}$/.test(mobile);

    if (!isValidMobile(formData.mobile)) {
      alert("Please enter valid WhatsApp number");
      return;
    }

     // ✅ SUBMIT KE TIME MOBILE VERIFIED TRUE
  const finalFormData = {
    ...formData,
    mobileVerified: true,
  };
    if (formData.loginType === "phone") {
    
      await updateUser(finalFormData);
      toast("Logged in via phone, profile updated");
      return;
    }

    await updateUser(finalFormData); 
  };

  /* -------- Change -------- */
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      let mobile = value.replace(/[^\d+]/g, "");
      if (!mobile.startsWith("+")) mobile = "+91" + mobile;
      mobile = mobile.slice(0, 13);

      setFormData((prev) => ({
        ...prev,
        mobile,
        mobileVerified: false,
      }));

      // 🔴 IMPORTANT: reset OTP flow
      // setIsOtpVerified(false);
      // setShowOtpModal(false);

      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  return (
    <div className="bg-bgBlue min-h-screen">
      {/* Logo */}
      <div className="p-4">
        <img src={Logo} alt="Learn2Earn24x7" className="w-32 h-14" />
      </div>

      {/* MAIN CONTENT */}
      <div
        className="max-w-6xl mx-auto
                flex flex-col lg:flex-row
                items-center justify-between
                min-h-[80vh]"
      >
        {/* LEFT IMAGE */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <img
            src={Image}
            alt="Details"
            className="w-48 h-48 lg:w-96 lg:h-96 object-contain"
          />
        </div>

        {/* RIGHT FORM */}
        <div className="w-full lg:w-1/2 flex flex-col items-center">
          <NotchedInput
            label="Full Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
          <NotchedInput
            label="Email "
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
          />

          <NotchedSelect
            label="Select Education"
            name="qualification"
            value={formData.qualification}
            onChange={handleChange}
            options={[
              { label: "10th", value: "10th" },
              { label: "12th", value: "12th" },
              { label: "Diploma / ITI", value: "Diploma/iti" },
              { label: "Graduate", value: "Graduate/Bachelor" },
              { label: "Post Graduate", value: "Post Graduate/Master" },
            ]}
          />

          <NotchedSelect
            label="Select State"
            name="userState"
            value={formData.userState}
            onChange={handleChange}
            options={states.map((state) => ({
              label: state.fullName,
              value: state.fullName,
            }))}
          />

          <NotchedInput
            label="WhatsApp Number"
            name="mobile"
            type="tel"
            value={formData.mobile}
            onChange={handleChange}
          />
          {/* TERMS CHECKBOX */}
          <div className="w-80 sm:w-72 md:w-96 lg:w-96 mt-6 flex items-start gap-2 text-white text-sm">
            <input
              type="checkbox"
              id="terms"
              checked={
                formData.termsAccepted &&
                formData.privacyAccepted &&
                formData.isAdultConfirmed
              }
              onChange={(e) => {
                const checked = e.target.checked;
                setFormData((prev) => ({
                  ...prev,
                  termsAccepted: checked,
                  privacyAccepted: checked,
                  isAdultConfirmed: checked,
                }));
              }}
              className="mt-1 accent-orange-400"
            />
            <label htmlFor="terms" className="cursor-pointer">
              I agree to the{" "}
              <a href="/terms&condition" className="text-purple underline">
                Terms & Conditions
              </a>
              ,{" "}
              <a href="/privacy-policy" className="text-purple underline">
                Privacy Policy
              </a>{" "}
              and confirm that I am
              <span className="font-semibold"> 18 years or above</span>
            </label>
          </div>

          {/* <input type="checkbox">I agree to the Terms of Service, Privacy Policy and confirm that I am 18 years or above</input> */}
          <button
            onClick={handleSubmit}
            className="w-56 h-12 mt-10 bg-orange-400 rounded-full
                       text-white text-xl shadow-[6px_6px_#A695AE]"
          >
            Submit
          </button>

          {/* <OTPModal
            isOpen={showOtpModal}
            mobile={formData.mobile}
            onClose={() => setShowOtpModal(false)}
            onVerified={async () => {
              setShowOtpModal(false);
              setIsOtpVerified(true);
              setFormData((prev) => ({
                ...prev,
                mobileVerified: true,
              }));
              await updateUser();
            }}
          /> */}

          <span className="text-white mt-8">Powered By Learn2Earn24x7</span>
        </div>
      </div>
      <ToastContainer position="top-center" />
    </div>
  );
};

export default WatsApp;